import {AuditData} from '../../../store/carAudit/reducerUtils';
import {RequiredParam} from './getRequiredFieldsFromCategories';

/**
 * A nested param is required only while the audit holds the values that put it on screen. The
 * comparison mirrors the one AuditFormField hands to the form's Condition, so a param is never
 * required while it is hidden - that would make the inspection impossible to submit.
 * A param reachable through several paths is required as soon as any one of them holds; an empty
 * chain carries no condition and therefore always holds.
 */
export const areRequiredParamConditionsMet = (
  fields: AuditData['fields'] | undefined,
  requiredParam: RequiredParam
) =>
  requiredParam.conditionChains.some((conditions) =>
    conditions.every((condition) => fields?.[condition.fieldName] === condition.value)
  );
